import React from 'react';
import { getLookupCustomerAuditHistoryProps } from 'react-scale/corp/components/Lookup/BaseLookupObject';
import { Extras } from 'react-scale/corp/components/Lookup/LookupTypes';
import CustomerAuditHistory from 'react-scale/corp/components/Lookup/sections/CustomerAuditHistory';
import HideableSection from 'react-scale/corp/components/UI/HideableSection';
import { ISensorFusionSubstageInstanceLookupDto } from '@scale/sensor-fusion-shared';

type SubstageInstanceCustomerAuditProps = {
  extras: Partial<Extras>;
  substageInstance: ISensorFusionSubstageInstanceLookupDto;
};

const SubstageInstanceCustomerAuditPanel = ({
  extras,
  substageInstance,
}: SubstageInstanceCustomerAuditProps) => {
  const customerAuditHistoryProps = getLookupCustomerAuditHistoryProps({
    object: substageInstance,
    scalerAccess: extras.scalerAccess,
  });

  if (!customerAuditHistoryProps) return null;

  return (
    <HideableSection name="Customer Audit History">
      <CustomerAuditHistory {...customerAuditHistoryProps} />
    </HideableSection>
  );
};

export default SubstageInstanceCustomerAuditPanel;
